import { Injectable } from "@angular/core";

import { dbToFloat, dbToFloats, dbToInts, floatsToDb, floatToDb, intsToDb } from "@dffedb/util";
import { NoteDbMapperService } from "@e-forsyning/common/note";

import { DbMaalerAflaesning } from "../model/db-maaler-aflaesning";
import { DbMaalerAflaesningMedNoter } from "../model/db-maaler-aflaesning-med-noter";
import { DbTaellevaerkAflaesning } from "../model/db-taellevaerk-aflaesning";
import { MaalerAflaesningMedNoter } from "../model/maaler-aflaesning-med-noter.model";
import { MaalerAflaesning } from "../model/maaler-aflaesning.model";
import { TaellevaerkAflaesning } from "../model/taellevaerk-aflaesning.model";

@Injectable({ providedIn: "root" })
export class MaalerAflaesningDbMapper {
    constructor(private readonly noteDbMapper: NoteDbMapperService) {}

    public dbToMaalerAflaesningMedNoter(data: DbMaalerAflaesningMedNoter, bilagUrlTemplate: string): MaalerAflaesningMedNoter {
        const maalerAflaesning = this.dbToMaalerAflaesning(data);
        const noter = this.noteDbMapper.dbToNoter(data.noter, bilagUrlTemplate);
        const result: MaalerAflaesningMedNoter = {
            ...maalerAflaesning,
            noter
        };
        return result;
    }

    public dbToMaalerAflaesning(data: DbMaalerAflaesning): MaalerAflaesning {
        const result: MaalerAflaesning = {
            maalerNr: data.maalerNr,
            maalerTypeId: dbToInts(data.maalerTypeId),
            taellevaerker: data.taellevaerker.map((t) => this.dbToTaellevaerkAflaesning(t))
        };
        return result;
    }

    public maalerAflaesningMedNoterToDb(data: MaalerAflaesningMedNoter): DbMaalerAflaesningMedNoter {
        const maalerAflaesning = this.maalerAflaesningToDb(data);
        const noter = this.noteDbMapper.noterToDb(data.noter);
        const result: DbMaalerAflaesningMedNoter = {
            ...maalerAflaesning,
            noter
        };
        return result;
    }

    public maalerAflaesningToDb(data: MaalerAflaesning): DbMaalerAflaesning {
        const result: DbMaalerAflaesning = {
            maalerNr: data.maalerNr,
            maalerTypeId: intsToDb(data.maalerTypeId),
            taellevaerker: data.taellevaerker.map((t) => this.taellevaerkAflaesningToDb(t))
        };
        return result;
    }

    private dbToTaellevaerkAflaesning(data: DbTaellevaerkAflaesning): TaellevaerkAflaesning {
        const result: TaellevaerkAflaesning = {
            aflaesning: dbToFloats(data.aflaesning),
            enhedType: data.enhedType,
            historiskAflaesning: dbToFloat(data.historiskAflaesning)
        };
        return result;
    }

    private taellevaerkAflaesningToDb(data: TaellevaerkAflaesning): DbTaellevaerkAflaesning {
        const result: DbTaellevaerkAflaesning = {
            aflaesning: floatsToDb(data.aflaesning),
            enhedType: data.enhedType,
            historiskAflaesning: floatToDb(data.historiskAflaesning)
        };
        return result;
    }
}
